module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Bold.ttf
// module id = 278
// module chunks = 0